// Translation files for German (default) and English

export const translations = {
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      services: 'Leistungen',
      faq: 'FAQ',
      contact: 'Kontakt',
      requestQuote: 'Angebot anfragen',
    },
    
    // Hero Section
    hero: {
      subtitle: 'A&D Service',
      title1: 'Ihr Partner für',
      title2: 'professionelle',
      title3: 'Dienstleistungen',
      description: 'Zuverlässig, schnell und sauber Von Hausmeisterservice über Instandhaltungsarbeiten bis zur Bodenverlegung – wir sind Ihr kompetenter Ansprechpartner in Essen und Umgebung.',
      cta1: 'Angebot anfragen',
      cta2: 'Jetzt anrufen',
    },
    
    // Services Section
    services: {
      subtitle: 'Unsere Leistungen',
      title: 'Was wir für Sie tun',
      description: 'Von der kleinen Reparatur über Renovierungsarbeiten bis zur fachgerechten Bodenverlegung: Entdecken Sie unser umfangreiches Angebot und lassen Sie uns Ihre Immobilie professionell betreuen.',
      viewAll: 'Alle Leistungen anzeigen',
      learnMore: 'Mehr erfahren',
      viewDetails: 'Details ansehen',
    },
    
    // Why Us Section
    whyUs: {
      subtitle: 'Warum A&D Service?',
      title1: 'Qualität, auf die Sie sich',
      title2: 'verlassen',
      title3: 'können',
      description: 'Mit jahrelanger Erfahrung und einem engagierten Team bieten wir Ihnen erstklassige Dienstleistungen zu fairen Preisen.',
      yearsExperience: 'Jahre Erfahrung',
      points: [
        { title: 'Pünktlich', desc: 'Wir halten unsere Termine ein.' },
        { title: 'Sauber', desc: 'Wir hinterlassen Ihre Räume makellos.' },
        { title: 'Fair', desc: 'Transparente und faire Preisgestaltung.' },
        { title: 'Schnell', desc: 'Effiziente Ausführung ohne Qualitätsverlust.' },
        { title: 'Qualität', desc: 'Hochwertige Materialien und Handwerk.' },
        { title: 'Zuverlässig', desc: 'Auf uns können Sie sich verlassen.' },
      ],
    },
    
    // CTA Section
    cta: {
      title1: 'Bereit für Ihr',
      title2: 'Projekt',
      description: 'Kontaktieren Sie uns noch heute für eine kostenlose Beratung und ein unverbindliches Angebot.',
      button: 'Kontakt aufnehmen',
    },
    
    // Services Page
    servicesPage: {
      subtitle: 'A&D Service',
      title1: 'Unsere',
      title2: 'Leistungen',
      description: 'Entdecken Sie unser umfangreiches Angebot an professionellen Dienstleistungen für Bau, Renovierung und Gebäudereinigung.',
      ctaTitle: 'Haben Sie Fragen zu unseren Leistungen?',
      ctaDescription: 'Wir beraten Sie gerne und erstellen Ihnen ein individuelles Angebot.',
      ctaButton: 'Jetzt anfragen',
    },
    
    // Service Detail
    serviceDetail: {
      backToServices: 'Zurück zu Leistungen',
      description: 'Beschreibung',
      whatWeDo: 'Was wir machen',
      forWhom: 'Für wen',
      process: 'Ablauf',
      benefits: 'Ihre Vorteile',
      gallery: 'Galerie',
      requestQuote: 'Angebot anfordern',
      formDescription: 'Füllen Sie das Formular aus und wir melden uns bei Ihnen.',
      otherServices: 'Weitere Leistungen',
    },
    
    // FAQ Page
    faqPage: {
      title1: 'Häufig gestellte',
      title2: 'Fragen',
      description: 'Hier finden Sie Antworten auf die häufigsten Fragen zu unseren Dienstleistungen.',
      searchPlaceholder: 'Fragen durchsuchen...',
      noResults: 'Keine Ergebnisse für Ihre Suche gefunden.',
      noFaqs: 'Keine FAQs verfügbar.',
      resetSearch: 'Suche zurücksetzen',
      ctaTitle: 'Haben Sie weitere Fragen?',
      ctaDescription: 'Wir helfen Ihnen gerne weiter. Kontaktieren Sie uns für eine persönliche Beratung.',
      ctaButton: 'Kontakt aufnehmen',
    },
    
    // Contact Page
    contactPage: {
      subtitle: 'A&D Service',
      title1: 'Kontakt &',
      title2: 'Angebot',
      description: 'Haben Sie ein Projekt im Sinn? Kontaktieren Sie uns für eine kostenlose Beratung und ein unverbindliches Angebot.',
      infoTitle: 'Kontaktinformationen',
      infoDescription: 'Wir freuen uns auf Ihre Anfrage! Rufen Sie uns an, schreiben Sie uns eine E-Mail oder füllen Sie das Kontaktformular aus.',
      phone: 'Telefon',
      email: 'E-Mail',
      location: 'Standort',
      availability: 'Erreichbarkeit',
      availabilityHours: 'Mo - Sa: 07:00 - 19:00 Uhr',
      formTitle: 'Angebot anfragen',
      formDescription: 'Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden bei Ihnen.',
      selectService: 'Gewünschte Leistung',
      selectPlaceholder: 'Bitte auswählen',
      messagePlaceholder: 'Beschreiben Sie Ihr Projekt oder Ihre Anfrage...',
      submitButton: 'Anfrage senden',
      submitting: 'Wird gesendet...',
      requiredFields: '* Pflichtfelder. Ihre Daten werden vertraulich behandelt.',
      successMessage: 'Anfrage erfolgreich gesendet! Wir melden uns bei Ihnen.',
      errorMessage: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    
    // Form Fields
    form: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      message: 'Nachricht',
      submit: 'Absenden',
    },
    
    // Footer
    footer: {
      description: 'Ihr zuverlässiger Partner für Hausmeisterservice, Renovierungen, Trockenbau & Entrümpelung in Essen und Umgebung. ',
      navigation: 'Navigation',
      contact: 'Kontakt',
      rights: 'Alle Rechte vorbehalten.',
      admin: 'Admin',
    },
    
    // Call Button
    callButton: 'Jetzt anrufen',
  },
  
  en: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      faq: 'FAQ',
      contact: 'Contact',
      requestQuote: 'Request Quote',
    },
    
    // Hero Section
    hero: {
      subtitle: 'A&D Service',
      title1: 'Your Partner for',
      title2: 'professional',
      title3: 'Services',
      description: 'Reliable, fast and clean. From caretaker services and maintenance work to floor laying – we are your competent partner in Essen and the surrounding area.',
      cta1: 'Request Quote',
      cta2: 'Call Now',
    },
    
    // Services Section
    services: {
      subtitle: 'Our Services',
      title: 'What we do for you',
      description: 'From small repairs and renovations to professional flooring installation: Discover our extensive range of services and let us professionally manage your property.',
      viewAll: 'View All Services',
      learnMore: 'Learn more',
      viewDetails: 'View details',
    },
    
    // Why Us Section
    whyUs: {
      subtitle: 'Why A&D Service?',
      title1: 'Quality you can',
      title2: 'rely',
      title3: 'on',
      description: 'With years of experience and a dedicated team, we offer you first-class services at fair prices.',
      yearsExperience: 'Years Experience',
      points: [
        { title: 'Punctual', desc: 'We keep our appointments.' },
        { title: 'Clean', desc: 'We leave your spaces spotless.' },
        { title: 'Fair', desc: 'Transparent and fair pricing.' },
        { title: 'Fast', desc: 'Efficient execution without quality loss.' },
        { title: 'Quality', desc: 'High-quality materials and craftsmanship.' },
        { title: 'Reliable', desc: 'You can count on us.' },
      ],
    },
    
    // CTA Section
    cta: {
      title1: 'Ready for your',
      title2: 'Project',
      description: 'Contact us today for a free consultation and a non-binding quote.',
      button: 'Get in Touch',
    },
    
    // Services Page
    servicesPage: {
      subtitle: 'A&D Service',
      title1: 'Our',
      title2: 'Services',
      description: 'Discover our comprehensive range of professional services for construction, renovation and building cleaning.',
      ctaTitle: 'Have questions about our services?',
      ctaDescription: 'We are happy to advise you and create an individual offer for you.',
      ctaButton: 'Request Now',
    },
    
    // Service Detail
    serviceDetail: {
      backToServices: 'Back to Services',
      description: 'Description',
      whatWeDo: 'What we do',
      forWhom: 'For whom',
      process: 'Process',
      benefits: 'Your Benefits',
      gallery: 'Gallery',
      requestQuote: 'Request Quote',
      formDescription: 'Fill out the form and we will get back to you.',
      otherServices: 'Other Services',
    },
    
    // FAQ Page
    faqPage: {
      title1: 'Frequently Asked',
      title2: 'Questions',
      description: 'Here you will find answers to the most common questions about our services.',
      searchPlaceholder: 'Search questions...',
      noResults: 'No results found for your search.',
      noFaqs: 'No FAQs available.',
      resetSearch: 'Reset search',
      ctaTitle: 'Have more questions?',
      ctaDescription: 'We are happy to help. Contact us for personal advice.',
      ctaButton: 'Get in Touch',
    },
    
    // Contact Page
    contactPage: {
      subtitle: 'A&D Service',
      title1: 'Contact &',
      title2: 'Quote',
      description: 'Have a project in mind? Contact us for a free consultation and a non-binding quote.',
      infoTitle: 'Contact Information',
      infoDescription: 'We look forward to your inquiry! Call us, send us an email or fill out the contact form.',
      phone: 'Phone',
      email: 'Email',
      location: 'Location',
      availability: 'Availability',
      availabilityHours: 'Mon - Sat: 07:00 - 19:00',
      formTitle: 'Request Quote',
      formDescription: 'Fill out the form and we will get back to you within 24 hours.',
      selectService: 'Desired Service',
      selectPlaceholder: 'Please select',
      messagePlaceholder: 'Describe your project or request...',
      submitButton: 'Send Request',
      submitting: 'Sending...',
      requiredFields: '* Required fields. Your data will be treated confidentially.',
      successMessage: 'Request sent successfully! We will contact you.',
      errorMessage: 'Error sending. Please try again.',
    },
    
    // Form Fields
    form: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      submit: 'Submit',
    },
    
    // Footer
    footer: {
      description: 'Your reliable partner for property maintenance, renovations, drywall construction, and junk removal in Essen and the surrounding area.',
      navigation: 'Navigation',
      contact: 'Contact',
      rights: 'All rights reserved.',
      admin: 'Admin',
    },
    
    // Call Button
    callButton: 'Call Now',
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      // Fallback to German
      value = translations['de'];
      for (const fallbackKey of keys) {
        if (value && value[fallbackKey]) {
          value = value[fallbackKey];
        } else {
          return key;
        }
      }
      break;
    }
  }
  
  return value;
};
